export const REQUEST_NEW_TICKET_CREATION = 'customContactForm/REQUEST_NEW_TICKET_CREATION';
export const CONTACT_FORM_UPDATE = 'customContactForm/CONTACT_FORM_UPDATE';
export const CONTACT_FORM_STATUS = 'customContactForm/CONTACT_FORM_STATUS';
export const CONTACT_FORM_ERROR = 'customContactForm/CONTACT_FORM_ERROR';
export const CONTACT_FORM_TICKET = 'customContactForm/CONTACT_FORM_TICKET';

export const requestNewTicketCreation = payload => ({
  type: REQUEST_NEW_TICKET_CREATION,
  payload
});

export const setContactForm = payload => ({
  type: CONTACT_FORM_UPDATE,
  payload
});

export const setFormStatus = payload => ({
  type: CONTACT_FORM_STATUS,
  payload
});

export const setFormError = payload => ({
  type: CONTACT_FORM_ERROR,
  payload
});

export const setFormTicketID = payload => ({
  type: CONTACT_FORM_TICKET,
  payload
});
